module.exports = __webpack_public_path__ + "img/bargains.02f6a89.svg";